import { render, staticRenderFns } from "./dashboardHome.vue?vue&type=template&id=5c2df2bc&scoped=true&"
import script from "./dashboardHome.vue?vue&type=script&lang=js&"
export * from "./dashboardHome.vue?vue&type=script&lang=js&"
import style0 from "./dashboardHome.vue?vue&type=style&index=0&id=5c2df2bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2df2bc",
  null
  
)

export default component.exports